// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e2119fc0","488":"8b3d979f"}[chunkId] + ".chunk.js";
};